var map = {
	"./address_autocomplete.coffee": 7324,
	"./announcements.coffee": 1575,
	"./autocomplete.coffee": 8561,
	"./be.coffee": 3596,
	"./bootstrap.coffee": 1089,
	"./clients.coffee": 9875,
	"./clock.coffee": 6265,
	"./documents.coffee": 3897,
	"./hello_coffee.coffee": 7256,
	"./lots.coffee": 641,
	"./orders.coffee": 4652,
	"./orders_fill_by_email.coffee": 5495,
	"./packages.coffee": 5624,
	"./product_sets.coffee": 8380,
	"./products.coffee": 4853,
	"./services.coffee": 4033,
	"./sources.coffee": 4025,
	"./statistics.coffee": 126,
	"./wallet_items.coffee": 171,
	"./warehouses.coffee": 5641,
	"coffee/address_autocomplete.coffee": 7324,
	"coffee/announcements.coffee": 1575,
	"coffee/autocomplete.coffee": 8561,
	"coffee/be.coffee": 3596,
	"coffee/bootstrap.coffee": 1089,
	"coffee/clients.coffee": 9875,
	"coffee/clock.coffee": 6265,
	"coffee/documents.coffee": 3897,
	"coffee/hello_coffee.coffee": 7256,
	"coffee/lots.coffee": 641,
	"coffee/orders.coffee": 4652,
	"coffee/orders_fill_by_email.coffee": 5495,
	"coffee/packages.coffee": 5624,
	"coffee/product_sets.coffee": 8380,
	"coffee/products.coffee": 4853,
	"coffee/services.coffee": 4033,
	"coffee/sources.coffee": 4025,
	"coffee/statistics.coffee": 126,
	"coffee/wallet_items.coffee": 171,
	"coffee/warehouses.coffee": 5641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6321;